import { render } from "./Dynamic.vue?vue&type=template&id=0a9136d2&scoped=true"
import script from "./Dynamic.vue?vue&type=script&lang=js"
export * from "./Dynamic.vue?vue&type=script&lang=js"

import "./Dynamic.vue?vue&type=style&index=0&id=0a9136d2&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9136d2"]])

export default __exports__